'use strict';

export default {

};
